// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.end-tournament {}
.end-tournament__form {}

.end-tournament-match-modal .modal2__container{
    width: 60%;
}

.end-tournament__form__element-title_section{
    margin: var(--space-and-half);
}

.grid-modal{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 0 var(--space-and-half);
}

.end-tournament__form__elements{
    padding-top: var(--space);
}

.grid-modal.end-tournament__form__elements__content{
    margin-left: var(--space-and-half);
    margin-right: var(--space-and-half);
    grid-template-columns: 1fr 2fr 2fr;
    padding: var(--space-x2);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    margin-bottom: var(--space-and-half);
}

.end-tournament__form__elements__content-col1 {
    grid-column: 1;
}

.end-tournament__form__elements__content-col2{
    grid-column: 2/3;
    margin-left: var(--space);
}

.end-tournament__form__elements__content__input {
    margin-bottom: 0;
    margin-top: 0px;
}

.end-tournament__form__elements__content__input .input-field-validation label {
    color: var( --basic-gray-color );
}

.grid-modal.end-tournament__form__elements__date {}

.end-tournament__form__elements__date__input {
    margin-top: var(--space-x3) !important;
    margin-bottom: 0;
}

.grid-modal.end-tournament__form__elements__field {
    margin-left: var(--space-and-half);
    margin-right: var(--space-and-half);
    margin-bottom: calc( var( --space-x3 ) + var( --space ) + var( --space-quarter ) + var( --space-eighth ) );
    grid-template-columns: 1fr 2fr 2fr;
    padding: var(--space-x2);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    margin-bottom: var(--space-and-half);
}

.end-tournament__form__elements__field__input {
    margin-top: var(--space-x3) !important;
    /* margin-bottom: 0; */
}

.end-tournament__form__persons {}

.end-tournament__form__persons__input {
    margin-left: var(--space-and-half);
    margin-right: var(--space-and-half);
}
.end-tournament__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.end-tournament__form__submit {
    margin-left: var(--space-and-half);
}

.end-tournament-titles__form__submit.baloa-table {
    color: var(--primary-very-dark-color);
    align-self: center;
    font-weight: var(--font-medium);
}

.end-tournament__form__element-title_section.baloa-table{
    color: var(--primary-very-dark-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-end-tournament-modal/EndTournamentMatchModal.styles.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB,uBAAuB;;AAEvB;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,kCAAkC;IAClC,wBAAwB;IACxB,kDAAkD;IAClD,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA,kDAAkD;;AAElD;IACI,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,0GAA0G;IAC1G,kCAAkC;IAClC,wBAAwB;IACxB,kDAAkD;IAClD,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA,gCAAgC;;AAEhC;IACI,kCAAkC;IAClC,mCAAmC;AACvC;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".end-tournament {}\n.end-tournament__form {}\n\n.end-tournament-match-modal .modal2__container{\n    width: 60%;\n}\n\n.end-tournament__form__element-title_section{\n    margin: var(--space-and-half);\n}\n\n.grid-modal{\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-gap: 0 var(--space-and-half);\n}\n\n.end-tournament__form__elements{\n    padding-top: var(--space);\n}\n\n.grid-modal.end-tournament__form__elements__content{\n    margin-left: var(--space-and-half);\n    margin-right: var(--space-and-half);\n    grid-template-columns: 1fr 2fr 2fr;\n    padding: var(--space-x2);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    margin-bottom: var(--space-and-half);\n}\n\n.end-tournament__form__elements__content-col1 {\n    grid-column: 1;\n}\n\n.end-tournament__form__elements__content-col2{\n    grid-column: 2/3;\n    margin-left: var(--space);\n}\n\n.end-tournament__form__elements__content__input {\n    margin-bottom: 0;\n    margin-top: 0px;\n}\n\n.end-tournament__form__elements__content__input .input-field-validation label {\n    color: var( --basic-gray-color );\n}\n\n.grid-modal.end-tournament__form__elements__date {}\n\n.end-tournament__form__elements__date__input {\n    margin-top: var(--space-x3) !important;\n    margin-bottom: 0;\n}\n\n.grid-modal.end-tournament__form__elements__field {\n    margin-left: var(--space-and-half);\n    margin-right: var(--space-and-half);\n    margin-bottom: calc( var( --space-x3 ) + var( --space ) + var( --space-quarter ) + var( --space-eighth ) );\n    grid-template-columns: 1fr 2fr 2fr;\n    padding: var(--space-x2);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    margin-bottom: var(--space-and-half);\n}\n\n.end-tournament__form__elements__field__input {\n    margin-top: var(--space-x3) !important;\n    /* margin-bottom: 0; */\n}\n\n.end-tournament__form__persons {}\n\n.end-tournament__form__persons__input {\n    margin-left: var(--space-and-half);\n    margin-right: var(--space-and-half);\n}\n.end-tournament__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.end-tournament__form__submit {\n    margin-left: var(--space-and-half);\n}\n\n.end-tournament-titles__form__submit.baloa-table {\n    color: var(--primary-very-dark-color);\n    align-self: center;\n    font-weight: var(--font-medium);\n}\n\n.end-tournament__form__element-title_section.baloa-table{\n    color: var(--primary-very-dark-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
